import { useResponsiveContext } from './ResponsiveContext';

export const useResponsive = useResponsiveContext;

